import Documents from './Documents'
import FileDetails from './FileDetails'

export default [{
  path: '/documents',
  name: 'Documents',
  component: Documents,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'My Documents'}
}, {
  path: '/file/:file_id',
  name: 'FileDetails',
  component: FileDetails,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'File Overview'}
}
]



// WEBPACK FOOTER //
// ./src/pages/document/router.js